import { createStandaloneToast, UseToastOptions } from '@ramp/components';
import { theme } from '@ramp/theme';

const { ToastContainer, toast: innerToast } = createStandaloneToast({
  theme,
  defaultOptions: {
    position: 'bottom-right',
    duration: 5000,
    isClosable: false,
    containerStyle: {
      maxWidth: '380px'
    }
  }
});

const notify = {
  success: (options: UseToastOptions) => innerToast({ ...options, status: 'success' }),
  info: (options: UseToastOptions) => innerToast({ ...options, status: 'info' }),
  warning: (options: UseToastOptions) => innerToast({ ...options, status: 'warning' }),
  error: (options: UseToastOptions) => innerToast({ ...options, status: 'error' })
};

export { notify, ToastContainer };
